export default __webpack_public_path__ + "static/media/2.e6c68449.png";